<template>
  <section class="login-form">
    <div class="container-fluid" v-if="!isUserNotConfirmed">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="login-form-img">
            <img
              :src="loginImg"
              alt="login form img"
            />
          </div>
        </div>

        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="login-form-inputs">
            <a class="back-btn" :href="homePageUrl">
              <img src="../../../Assets/Images/arrow-left.png" alt="arrow" />
              <span>{{ backBtn }}</span>
            </a>
            <div class="login-form-logo">
              <img src="../../../Assets/Images/logo-login.png" alt="EDA logo" />
            </div>
            <h3 class="generic-description">{{ loginSignIn }}</h3>
            <form v-on:submit.prevent="onSubmit" class="form-container">
              <div class="input-field">
                <input
                  type="text"
                  :placeholder="loginUserName"
                  v-model.trim="$v.formData.email.$model"
                />
                <p v-if="$v.formData.email.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.email.required"
                    >{{ loginUserNameRequired }}</span
                  >
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.email.checkLogin && $v.formData.email.required"
                    >{{ loginUserNameNotValid }}</span
                  >
                </p>
              </div>
              <div class="input-field">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  :placeholder="loginPassword"
                  v-model.trim="$v.formData.password.$model"
                />
                <p v-if="$v.formData.password.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.password.required"
                    >{{ loginPasswordRequired }}</span
                  >
                </p>
                <a
                  @click.prevent="togglePassword()"
                  href="javascript:void(0)"
                  class="show-hide-password"
                >
                  <span class="visibility">
                    <svg
                      v-if="showPassword"
                      xmlns="http://www.w3.org/2000/svg"
                      width="27.925"
                      height="20.855"
                      viewBox="0 0 27.925 20.855"
                    >
                      <g id="Icon_feather-eye" transform="translate(-.5 -5)">
                        <path
                          id="Path_6588"
                          d="M1.5 15.427S6.214 6 14.463 6s12.963 9.427 12.963 9.427-4.714 9.427-12.963 9.427S1.5 15.427 1.5 15.427z"
                          class="icon-path"
                        />
                        <path
                          id="Path_6589"
                          d="M20.57 17.035a3.535 3.535 0 1 1-3.535-3.535 3.535 3.535 0 0 1 3.535 3.535z"
                          class="icon-path"
                          transform="translate(-2.573 -1.608)"
                        />
                      </g>
                    </svg>
                    <svg
                      v-if="!showPassword"
                      xmlns="http://www.w3.org/2000/svg"
                      width="28.046"
                      height="28.046"
                      viewBox="0 0 28.046 28.046"
                    >
                      <g
                        id="Icon_feather-eye-off"
                        transform="translate(-.086 -.086)"
                      >
                        <path
                          id="Path_6613"
                          d="M20.918 21.979a11.543 11.543 0 0 1-6.809 2.361C6.085 24.34 1.5 15.17 1.5 15.17a21.149 21.149 0 0 1 5.8-6.809m4.4-2.086A10.454 10.454 0 0 1 14.109 6c8.024 0 12.609 9.17 12.609 9.17a21.206 21.206 0 0 1-2.476 3.657m-7.7-1.227a3.439 3.439 0 1 1-4.86-4.86"
                          class="icon-path"
                          transform="translate(0 -1.061)"
                        />
                        <path
                          id="Path_6614"
                          d="M1.5 1.5l25.218 25.218"
                          class="icon-path"
                        />
                      </g>
                    </svg>
                  </span>
                </a>
                <div class="rememberMe-forgetPassword">
                  <label class="custom-checkbox">
                    <input v-model="formData.rememberMe" type="checkbox" />
                    <span class="custom-checkbox__img">
                      <img src="../../../Assets/Images/checked-icon.png" alt="icon" />
                    </span>
                    {{ loginRememberMe }}
                  </label>
                  <a :href="forgetPasswordPageUrl">{{ loginForgetPassword }}</a>
                </div>
              </div>
              <button type="submit" class="custom-btn __yellow">
                {{ login }}
              </button>
            </form>
            <p class="form-signup">
              {{ loginNotHaveAccount }}
              <a :href="registerUrl">{{ loginSignUp }}</a>
            </p>
            <div class="news-letter__loader" v-if="isLoading">
              <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
            </div>
          </div>
        </div>
      </div>
      <div class="toaster" v-bind:class="{ 'show-toaster': showRegisterMes }">
        {{ LoginMessages }}
      </div>
    </div>
    <otp-component
      v-if="isUserNotConfirmed"
      v-on:childToParent="backToLogin"
      :objOtp="optPage"
    ></otp-component>
  </section>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";
import otpComponent from "../Otp/OTP.vue";

Vue.use(Vuelidate);

let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";
let language = window.CurrentLanguage.CurrentLanguage.split('-')[0];

let emailValidation = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
let profileIdCheck = /\b[A-Za-z]{3}[0-9]{3}\b/;

const checkLogin = value => {
    if (emailValidation.test(value) || profileIdCheck.test(value)) {
        return true;
    } else {
        return false;
    }
}

export default {
  props: {
    loginPageImgDesktop: {
        type: String,
    },
    loginPageImgMobile: {
        type: String,
    },
    login: {
      type: String,
    },
    loginSignIn: {
      type: String,
    },
    loginSignUp: {
      type: String,
    },
    loginUserName: {
      type: String,
    },
    loginUserNameRequired: {
      type: String,
    },
    loginUserNameNotValid: {
      type: String,
    },
    loginPassword: {
      type: String,
    },
    loginPasswordRequired: {
      type: String,
    },
    loginRememberMe: {
      type: String,
    },
    loginForgetPassword: {
      type: String,
    },
    loginNotHaveAccount: {
      type: String,
    },
    OTPScreenTitle: {
      type: String,
    },
    OTPScreenConfirmEmail: {
      type: String,
    },
    OTPScreenVerifyCode: {
      type: String,
    },
    OTPScreenVerifyCodeRequired: {
      type: String,
    },
    OTPScreenVerifyCodeNotValid: {
      type: String,
    },
    submit: {
      type: String,
    },
    backBtn: {
      type: String,
    },
    registerUrl: {
      type: String,
    },
    isLoginPage: {
      type: Boolean,
    },
    homePageUrl: {
      type: String,
    },
    loginPageUrl: {
      type: String,
    },
    forgetPasswordPageUrl: {
      type: String,
    },
    HomePage: {
      type: String,
    },
    isForgetPasswordPage: {
      type: Boolean,
    },
    registrationSuccessfully: {
      type: String,
    },
    passwordSuccessMessage: {
      type: String,
    }
  },
  components: {
    otpComponent,
  },
  data() {
    return {
      isLoading: false,
      isUserNotConfirmed: false,
      loginImg: this.loginPageImgDesktop,
      showPassword: false,
      LoginMessages: "",
      showRegisterMes: false,
      optPage: {},
      formData: {
        email: "",
        password: "",
        rememberMe: false,
      },
    };
  },
  validations: {
    formData: {
      email: {
        required,
        checkLogin
      },
      password: {
        required,
      },
    },
  },
  methods: {
      onSubmit() {
      this.$v.formData.$touch();
      if (this.$v.formData.$anyError) {
        return;
      } else {
        this.isLoading = true;
        let formObj = {
          EdaID: this.formData.email,
          Password: this.formData.password,
          RememberMe: this.formData.rememberMe,
        };

        let headers = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        axios
          .post(`${apiUrl}/Umbraco/Surface/Users/login`, formObj, headers)
            .then((res) => {
            if (
              res.data.IsOperationSucceed == true &&
              res.data.SendOTP == false
            ) {
                localStorage.setItem("token", res.data.Token);
                //if (formObj.RememberMe) {
                //    localStorage.setItem("token", res.data.Token);
                //    sessionStorage.setItem("token", res.data.Token);
                //} else if (!formObj.RememberMe) {
                //    sessionStorage.setItem("token", res.data.Token);
                //}
                if (res.data.PreviousPageUrl != '') {
                    location.href = res.data.PreviousPageUrl;
                } else {
                    location.href = `/${language}`;
                }
            } else {
              if (res.data.SendOTP == true) {
                this.optPage.userEmail = res.data.Email;
                this.optPage.EdaID = res.data.ProfileID;
                this.isLoading = false;
                this.LoginMessages = res.data.Message;
                this.showRegisterMes = true;
                setTimeout(() => {
                  this.showRegisterMes = false;
                  this.isUserNotConfirmed = true;
                }, 2000);
              } else {
                this.isLoading = false;
                this.LoginMessages = res.data.Message;
                this.showRegisterMes = true;
                setTimeout(() => {
                  this.showRegisterMes = false;
                }, 2000);
              }
            }
          })
            .catch(() => {
            this.isLoading = false;
          });
      }
    },
    setCookie(cname, cvalue, exHours) {
      var d = new Date();
      d.setTime(d.getTime() + exHours * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    backToLogin(value) {
      this.isUserNotConfirmed = value;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  },
  beforeMount() {
      let token = localStorage.getItem("token");

      if (performance.navigation.type == 2) {
          if (token) {
              window.location.href = window.location.origin;
          }
      }
  },
  mounted() {
      if (window.innerWidth <= 1025) {
          this.loginImg = this.loginPageImgMobile
      }
    this.optPage = {
      backBtn: this.backBtn,
      userEmail: "",
      EdaID:"",
      isLoginPage: this.isLoginPage,
      isForgetPasswordPage: this.isForgetPasswordPage,
      registerUrl: this.registerUrl,
      homeUrl: this.homePageUrl,
      loginUrl: this.loginPageUrl,
      OTPTitle: this.OTPScreenTitle,
      OTPConfirmEmail: this.OTPScreenConfirmEmail,
      OTPVerifyCode: this.OTPScreenVerifyCode,
      OTPVerifyCodeRequired: this.OTPScreenVerifyCodeRequired,
      OTPVerifyCodeNotValid: this.OTPScreenVerifyCodeNotValid,
      submit: this.submit,
      login: this.login,
      home: this.HomePage,
      registeredSuccess: this.registrationSuccessfully,
      passwordSuccess: this.passwordSuccessMessage,
      imgDesktop: this.loginPageImgDesktop,
      imgMobile: this.loginPageImgMobile,
    };
  },
};
</script>
